<div *ngIf="mostrarModal" class="modal fade show d-block" tabindex="-1" role="dialog"
  style="background-color: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-lg" role="document" style="max-width: 900px; margin-top: 5vh;">
    <div class="modal-content" style="max-height: 80vh;">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left">
          <mdb-icon fas icon="file-invoice"></mdb-icon>
          Resultado
        </h4>
        <button type="button" class="close" (click)="cerrarModal()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="datos && datos.length > 0">
          <h5>Las siguientes Notas de Venta fueron convertidas en Facturas:</h5>

          <div class="table-responsive">
            <table class="table table-striped table-hover table-sm align-middle"
              style="width: 100%; table-layout: fixed;">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col" class="text-center" style="width: 15%;">Nro. Factura</th>
                  <th scope="col" class="text-center" style="width: 15%;">Nota de Venta</th>
                  <th scope="col" class="text-center" style="width: 25%;">Cliente</th>
                  <th scope="col" class="text-center" style="width: 20%;">Vendedor</th>
                  <th scope="col" class="text-center" style="width: 12.5%;">Total Neto</th>
                  <th scope="col" class="text-center" style="width: 12.5%;">Total Bruto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dato of datosPaginados">
                  <td class="text-center">{{dato.folio | numerico}}</td>
                  <td class="text-center">{{dato.nota_venta}}</td>
                  <td class="text-center"
                    style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                    title="{{dato.cliente_nombre}}">{{dato.cliente_nombre}}</td>
                  <td class="text-center"
                    style="max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                    title="{{dato.vendedor_nombre}}">{{dato.vendedor_nombre ? dato.vendedor_nombre : 'N/A'}}</td>
                  <td class="text-center">$ {{dato.monto_total_neto | numerico}}</td>
                  <td class="text-center">$ {{dato.monto_total | numerico}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginación -->
          <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="datos.length > paginationContext.RecordsByPage"></app-pagination>

          <!-- Totales -->
          <div class="table-responsive mt-3">
            <table class="table table-striped table-hover table-sm align-middle">
              <tbody style="text-align:right;">
                <tr>
                  <td class="col-8" style="font-weight: bold; font-size: 15px;">
                    <span style="color: red;">Total Neto: </span>
                    <span>$ {{sumMontoNeto | numerico}}</span>
                  </td>
                  <td class="col-4" style="font-weight: bold; font-size: 15px;">
                    <span style="color: red;">Total Bruto: </span>
                    <span>$ {{sumMontoBruto | numerico}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="!datos || datos.length === 0" class="text-center">
          <mdb-icon fas icon="info-circle" size="3x" class="text-muted"></mdb-icon>
          <h5 class="mt-3 text-muted">No hay resultados para mostrar</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm waves-light" (click)="cerrarModal()" mdbWavesEffect>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>